import { initialsFormatter } from '@asn/formatters';

import { AbstractControl, FormGroup } from '@angular/forms';

import { PersonalDetailsForm } from '../personal-details.model';

import { ApMatchNamesService } from './match-names.service';

/**
 * Validates the firstnames against the initials
 */
export class ApMatchFirstnamesValidator {
    static needsValidation(control: AbstractControl) {
        return control.value && !control.disabled;
    }

    static createValidator(matchNamesService: ApMatchNamesService) {
        return (initialsKey: string, firstnamesKey: string) =>
            (group: FormGroup<PersonalDetailsForm>): { [key: string]: any } | null => {
                const initialsControl: AbstractControl = group.controls[initialsKey];
                const firstnamesControl: AbstractControl = group.controls[firstnamesKey];

                if (this.needsValidation(initialsControl) && this.needsValidation(firstnamesControl)) {
                    const splitModelString = matchNamesService.splitInitialsAndFirstNames(
                        initialsFormatter.format(initialsControl.value.trim())
                    );
                    const splitAttrString = matchNamesService.splitInitialsAndFirstNames(firstnamesControl.value.trim());

                    const hasSameLength = matchNamesService.isValidLength(splitModelString, splitAttrString);
                    let namesValid = false;
                    if (hasSameLength) {
                        namesValid = matchNamesService.isValidFirstNamesAndInitials(splitModelString, splitAttrString);
                    }
                    return hasSameLength && namesValid ? null : { firstnamesMismatch: true };
                }
                return null;
            };
    }
}
